import { defaultTheme } from "@cobee/cobee-ui";
import styled from "styled-components";

export const CustomTextField = styled.textarea`
  margin-top: 8px;
  margin-bottom: 30px;
  width: 100%;
  height: 96px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #cfdae5;
  border-radius: 12px;
  resize: none;
`;

export const styles = {
  titleStyle: {
    marginBottom: defaultTheme.spacing(2),
  },
};
